export const DEFAULT_ERROR_MESSAGE = 'An unknown error occurred.';

export function toErrorMessage(errorType: string): string {
  // We will map this to translations we can show to the user
  switch (errorType) {
    default:
      return DEFAULT_ERROR_MESSAGE;
  }
}
